export const FREQUENT_FLYER_TITLE = "Frequent Flyer Details";
export const ADDITIONAL_INFO_TITLE = "Additional Information";
export const ADULT_TITLE = "Adult";
export const CHILD_TITLE = "Child";
export const INFANT_SEAT_TITLE = "Infant";
export const INFANT_LAP_TITLE = "Infant";
export const UPDATE_TEXT = "Updating Passengers";
export const VALIDATE_TEXT = "Validating Passengers";
export const ADD_TRAVELER_INFO_TEXT = "Add Traveler Information";
export const ADD_TRAVELERS_TEXT = "Add Primary Traveler";
export const ADD_TRAVELERS_TEXT_UPDATED = "Select or Add Traveler";
export const ADD_TRAVELER_ERROR_MESSAGE =
  "Add or choose one traveler to continue.";
export const TRAVELER_INFORMATION_TITLE = (isMultiroomAmadeus: boolean) =>
  isMultiroomAmadeus ? "Traveler Information" : "Add Primary Traveler";
export const COMPLETE_PROFILE_TITLE = "Complete traveler profile";
export const COMPLETE_PROFILE_SUBTITLE =
  "Please make sure all the information added matches the government issued ID for this traveler as this will be applied to travel bookings moving forward. Traveler information will be accessible to all Admins.";
export const EDIT_TRAVELER_TITLE = "Edit traveler profile";
export const EDIT_TRAVELER_SUBTITLE =
  "Please make sure all the information added matches the government issued ID for this traveler as this will be applied to travel bookings moving forward.";
